import { BackendModel, BackendService } from '../../core/backend.service';

export class Genero extends BackendModel {

  static path = '/parametricas/generos/';

  description: string;

  constructor(protected backendService: BackendService, model?: Genero) {
    super(backendService, model);
  }

}



// WEBPACK FOOTER //
// ./src/app/security/user/genero.model.ts